import { gql } from '@apollo/client';

export const GET_ECD_PARTIAL_CARE_FACILITY_SURVEY = gql`
  query GetECDPartialCareFacilitySurvey {
    survey: getECDPartialCareFacilitySurvey {
      triggers {
        expression
        fromName
        setToName
        setValue
        type
      }
      pages {
        elements {
          elements {
            category
            choices
            description
            hideNumber
            id
            isRequired
            name
            questionNumber
            readOnly
            requirePhotos
            title
            type
            visible
            visibleIf
            tag
          }
          questionTitleLocation
          name
          title
          type
        }
        name
        title
      }
      showProgressBar
      showQuestionNumbers
      title
      templateId
    }
  }
`;
